
import { defineComponent, onBeforeMount, ref } from 'vue';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { invokegetSkillProf, invokeReport } from '@/utils/admin/harvest_report';
// eslint-disable-next-line
// import router from '@/router';
// import { XIcon } from 'vue-feather-icons';

export default defineComponent({
  name: 'AssignProxy',
  setup() {
    const skills = ref();
    const proficiency = ref();
    const renderReady = ref();
    const selectedSkill = ref();
    const selectedProficiency = ref();
    const userRole = ref();
    const errorMessage = ref();
    const successMessage = ref();
    const threshold = ref();
    const numErrMessage = ref();
    const showScreen = ref(true);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const triggerReport = async () => {
      renderReady.value = false;
      if (selectedSkill.value === undefined) {
        errorMessage.value = 'Select Skill';
        setTimeout(() => {
          errorMessage.value = null;
        }, 6000);
      } else if (!/^[0-9]+$/.test(threshold.value)) {
        numErrMessage.value = 'Enter only Number';
        setTimeout(() => {
          numErrMessage.value = null;
        }, 6000);
      } else {
        const reportData = {
          skill_id: selectedSkill.value,
          proficiency_id: selectedProficiency.value,
          threshold: threshold.value,
        };
        await invokeReport('/admin/report/harvestLJ', reportData);
        successMessage.value = 'The harvesting report is being processed. You should get that over email in next 15 minutes';
        setTimeout(() => {
          successMessage.value = null;
        }, 6000);
      }
      renderReady.value = true;
    };
    const getSkillandProf = async () => {
      renderReady.value = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const dataRes: any = await invokegetSkillProf('/getAllSkillProf?skill_type=all');
      skills.value = dataRes.skill;
      proficiency.value = dataRes.proficiency;
      renderReady.value = true;
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedSkill = async (e: any) => {
      // console.log(e.target.removeAttr('selected'));
      selectedSkill.value = e.target.value;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedProficiency = async (e: any) => {
      selectedProficiency.value = e.target.value;
      if (selectedProficiency.value === 'Select Proficiency') {
        selectedProficiency.value = '';
      }
    };

    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        console.log('inside length');
        if (userRole.value.includes('System Admin') || userRole.value.includes('Proxy Admin') || userRole.value.includes('Community Manager') || userRole.value.includes('Knowledge Manager')) {
          showScreen.value = true;
          getSkillandProf();
        } else {
          showScreen.value = false;
        }
      }
    });
    return {
      skills,
      proficiency,
      renderReady,
      getSelectedSkill,
      getSelectedProficiency,
      getSkillandProf,
      showScreen,
      triggerReport,
      errorMessage,
      successMessage,
      threshold,
      numErrMessage,
    };
  },
});
